import React, { useState } from 'react';

export default function PasswordModal({ open, onSubmit, onClose, checkPassword }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  if (!open) return null;

  const handleSubmit = () => {
    if (checkPassword(password)) {
      setPassword('');
      setError(false);
      onSubmit();
    } else {
      setError(true);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <>
      <div className="task-modal-overlay password-modal-overlay" onClick={onClose} />
      <div className="task-modal password-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Enter password</h3>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          className="password-modal-input"
          autoFocus
        />
        {error && (
          <div className="password-modal-error">Wrong password</div>
        )}
        <div className="password-modal-actions">
          <button className="intro-button" onClick={handleSubmit}>
            Inject
          </button>
          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  );
}
